function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useRef } from 'react';
import { withNativeProps } from '../../utils/native-props';
import List from '../list';
import { DownOutline } from 'antd-mobile-icons';
import classNames from 'classnames';
import { useSpring, animated } from '@react-spring/web';
import { usePropsValue } from '../../utils/use-props-value';
import { useMount } from 'ahooks';
import { useShouldRender } from '../../utils/should-render';
import { useIsomorphicUpdateLayoutEffect } from '../../utils/use-isomorphic-update-layout-effect';
import { traverseReactNode } from '../../utils/traverse-react-node';
var classPrefix = "adm-collapse";
export var CollapsePanel = function CollapsePanel() {
  return null;
};

var CollapsePanelContent = function CollapsePanelContent(props) {
  var visible = props.visible;
  var innerRef = useRef(null);
  var shouldRender = useShouldRender(visible, props.forceRender, props.destroyOnClose);

  var _useSpring = useSpring(function () {
    return {
      from: {
        height: 0
      },
      config: {
        precision: 0.01,
        mass: 1,
        tension: 200,
        friction: 25,
        clamp: true
      }
    };
  }),
      _useSpring2 = _slicedToArray(_useSpring, 2),
      height = _useSpring2[0].height,
      api = _useSpring2[1];

  useMount(function () {
    if (!visible) return;
    var inner = innerRef.current;
    if (!inner) return;
    api.start({
      height: inner.offsetHeight,
      immediate: true
    });
  });
  useIsomorphicUpdateLayoutEffect(function () {
    var inner = innerRef.current;
    if (!inner) return;

    if (visible) {
      api.start({
        height: inner.offsetHeight
      });
    } else {
      api.start({
        height: inner.offsetHeight,
        immediate: true
      });
      api.start({
        height: 0
      });
    }
  }, [visible]);
  return /*#__PURE__*/React.createElement(animated.div, {
    className: "".concat(classPrefix, "-panel-content"),
    style: {
      height: height.to(function (v) {
        if (height.idle && visible) {
          return 'auto';
        } else {
          return v;
        }
      })
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classPrefix, "-panel-content-inner"),
    ref: innerRef
  }, /*#__PURE__*/React.createElement(List.Item, null, shouldRender && props.children)));
};

export var Collapse = function Collapse(props) {
  var _a;

  var panels = [];
  traverseReactNode(props.children, function (child) {
    if (! /*#__PURE__*/React.isValidElement(child)) return;
    var key = child.key;
    if (typeof key !== 'string') return;
    panels.push(child);
  });

  var _usePropsValue = usePropsValue(props.accordion ? {
    value: props.activeKey === undefined ? undefined : props.activeKey === null ? [] : [props.activeKey],
    defaultValue: props.defaultActiveKey === undefined || props.defaultActiveKey === null ? [] : [props.defaultActiveKey],
    onChange: function onChange(v) {
      var _a, _b;

      (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, (_b = v[0]) !== null && _b !== void 0 ? _b : null);
    }
  } : {
    value: props.activeKey,
    defaultValue: (_a = props.defaultActiveKey) !== null && _a !== void 0 ? _a : [],
    onChange: props.onChange
  }),
      _usePropsValue2 = _slicedToArray(_usePropsValue, 2),
      activeKey = _usePropsValue2[0],
      setActiveKey = _usePropsValue2[1];

  var activeKeyList = activeKey === null ? [] : Array.isArray(activeKey) ? activeKey : [activeKey];
  return withNativeProps(props, /*#__PURE__*/React.createElement("div", {
    className: classPrefix
  }, /*#__PURE__*/React.createElement(List, null, panels.map(function (panel) {
    var key = panel.key;
    var active = activeKeyList.includes(key);

    function handleClick(event) {
      var _a, _b;

      if (props.accordion) {
        if (active) {
          setActiveKey([]);
        } else {
          setActiveKey([key]);
        }
      } else {
        if (active) {
          setActiveKey(activeKeyList.filter(function (v) {
            return v !== key;
          }));
        } else {
          setActiveKey([].concat(_toConsumableArray(activeKeyList), [key]));
        }
      }

      (_b = (_a = panel.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, event);
    }

    var renderArrow = function renderArrow() {
      var arrow = /*#__PURE__*/React.createElement(DownOutline, null);

      if (props.arrow !== undefined) {
        arrow = props.arrow;
      }

      if (panel.props.arrow !== undefined) {
        arrow = panel.props.arrow;
      }

      return typeof arrow === 'function' ? arrow(active) : /*#__PURE__*/React.createElement("div", {
        className: classNames("".concat(classPrefix, "-arrow"), _defineProperty({}, "".concat(classPrefix, "-arrow-active"), active))
      }, arrow);
    };

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: key
    }, withNativeProps(panel.props, /*#__PURE__*/React.createElement(List.Item, {
      className: "".concat(classPrefix, "-panel-header"),
      onClick: handleClick,
      disabled: panel.props.disabled,
      arrow: renderArrow()
    }, panel.props.title)), /*#__PURE__*/React.createElement(CollapsePanelContent, {
      visible: active,
      forceRender: !!panel.props.forceRender,
      destroyOnClose: !!panel.props.destroyOnClose
    }, panel.props.children));
  }))));
};